"use client"
import { createContext, useContext, type ReactNode } from "react"
import {
  DEFAULT_ANIMATION_TUNING,
  type AnimationTuning,
} from "./animationTuningDefaults"

// The live tuning values every in-scope HUD animation reads. The context
// DEFAULTS to the saved JSON values, so any consumer that calls
// useAnimationTuning() outside a provider (i.e. everywhere in the real app)
// gets exactly the persisted numbers — production behavior is unchanged. The
// HUD-animation studio wraps its preview subtree in AnimationTuningProvider
// with live-edited values so dragging a slider retunes the HUD instantly.
const AnimationTuningContext = createContext<AnimationTuning>(
  DEFAULT_ANIMATION_TUNING
)

export const AnimationTuningProvider = ({
  value,
  children,
}: {
  value: AnimationTuning
  children: ReactNode
}) => (
  <AnimationTuningContext.Provider value={value}>
    {children}
  </AnimationTuningContext.Provider>
)

export const useAnimationTuning = (): AnimationTuning =>
  useContext(AnimationTuningContext)
